import React, { useContext, useEffect } from "react";
import { Routes, Route, Navigate, useLocation, Outlet } from "react-router-dom";

import { Context } from "../config/AuthContext";

import { Login } from "../pages/Login";
import { Dashboard } from "../pages/Dashboard";
import Usuarios from "../pages/Usuarios";
import GruposEconomicos from "../pages/GruposEconomicos";
import BancoFiltros from "../pages/BancoFiltros";
import ContaProtheus from "../pages/ContaProtheus";
import BancaProtheus from "../pages/BancaProtheus";
import ExtratoBancario from "../pages/ExtratoBancário";
import ImportacoesExtrato from "../pages/ImportacoesExtrato";
import ConciliacaoContabil from "../pages/ConciliacaoContabil";
import Rotas from "../pages/Rotas";
import Verbas from "../pages/Verbas";
import Impostos from "../pages/Impostos";
import Folhas from "../pages/Folhas";
import Calculo20s from "../pages/Calculo20S";
import Clientes from "../pages/Clientes";
import { RedefinirSenha } from "../pages/RedefinirSenha";
import PageNotFound from "../pages/PageNotFound";
import { verificarTokenHandler } from "../services/auth.service";
import { Token } from "../utils/localStorage.util";
import Servicos from "../pages/Serviços";
import CondicaoComercial from "../pages/CondicaoComercial";
import Faturamento from "../pages/Faturamento";
import ValoresFatura from "../pages/ValoresFatura";
import ExportXml from "../pages/ExportXml";
import CodFornecedor from "../pages/CodFornecedor";
// Histórico de Extrato desabilitado
// import HistoricoExtrato from "../pages/HistoricoExtrato";
import VerbasManuais from "../pages/VerbasManuais";
import GruposUsuarios from "../pages/GruposUsuarios";
import AjustesVerbas from "../pages/AjustesVerbas";
import FolhasManuais from "../pages/FolhasManuais";
import ResumoGeral from "../pages/ResumoGeral";
import ViewExportPdf from "../pages/Faturamento/ViewExportPdf";
import ContaDominio from "../pages/ContaDominio";
import ProcessosInternos from "../pages/ProcessosInternos";
import Template from "../pages/ProcessosInternos/template";

const AuthWrapper = () => {
  const location = useLocation();
  const { authenticated, handleLogout } = useContext(Context);

  useEffect(() => {
    verificarTokenHandler({
      token: Token.getToken(),
      validacaoFront: true,
    })
      .then((response) => {
        if (!response.sucesso) handleLogout();
      })
      .catch((err) => {
        handleLogout();
      });
  }, [location]);

  return authenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace state={{ from: location }} />
  );
};

const LoginWrapper = () => {
  const location = useLocation();
  const { authenticated } = useContext(Context);

  return authenticated ? (
    <Navigate to="/dashboard" replace state={{ from: location }} />
  ) : (
    <Outlet />
  );
};

export default function RoutesAdm() {
  return (
    <Routes>
      <Route element={<LoginWrapper />}>
        <Route index path="/" element={<Login />} />
        {/* REDEFINIR SENHA */}
        <Route path="/redefinir-senha" element={<RedefinirSenha />} />
      </Route>

      {/* <Route > */}
      <Route path="/processos-internos" element={<Template />} />
      {/* </Route> */}

      <Route element={<AuthWrapper />}>
        <Route path="/dashboard" element={<Dashboard />} />
        {/* CLIENTES */}
        <Route path="/clientes/">
          <Route path="empresas" element={<Clientes />} />
          <Route path="grupos-economicos" element={<GruposEconomicos />} />
        </Route>

        {/* CONCILIACAO */}
        <Route path="/conciliacao/">
          <Route path="codigo-fornecedor" element={<CodFornecedor />} />
          <Route path="contas-bancarias" element={<BancaProtheus />} />
          <Route path="contas-dominio" element={<ContaDominio />} />
          <Route path="contas-protheus" element={<ContaProtheus />} />
          <Route path="extratos-bancarios" element={<ExtratoBancario />} />
          <Route path="importacoes-extrato" element={<ImportacoesExtrato />} />
          {/* Histórico de Extrato desabilitado */}
          {/* <Route path="historico-extrato" element={<HistoricoExtrato />} /> */}
          <Route path="vinculo-contas" element={<BancoFiltros />} />
          <Route
            path="conciliacao-contabil"
            element={<ConciliacaoContabil />}
          />
        </Route>

        {/* CONFIGURACOES */}
        <Route path="/configuracoes/">
          {/* TODO Menus */}
          <Route path="rotas" element={<Rotas />} />
          <Route path="servicos" element={<Servicos />} />
          <Route path="usuarios" element={<Usuarios />} />
          <Route path="grupos-usuarios" element={<GruposUsuarios />} />
        </Route>

        {/* ESOCIAL */}
        <Route path="/esocial/">
          <Route path="ajustes-verbas" element={<AjustesVerbas />} />
          <Route path="verbas-manuais" element={<VerbasManuais />} />
          <Route path="bases-calculo" element={<Calculo20s />} />
          <Route path="folha-esocial" element={<Folhas />} />
          <Route path="resumo-geral" element={<ResumoGeral />} />
          <Route path="folha-manual" element={<FolhasManuais />} />
          <Route path="impostos" element={<Impostos />} />
          <Route path="verbas" element={<Verbas />} />
        </Route>

        {/* FINANCEIRO */}
        <Route path="/financeiro/">
          <Route path="condicao-comercial" element={<CondicaoComercial />} />
          <Route path="faturamento" element={<Faturamento />} />
          <Route path="valores-fatura" element={<ValoresFatura />} />
          <Route path="export" element={<ViewExportPdf />} />
        </Route>

        {/* EXPORTAR XML */}
        <Route path="/export-xml/" element={<ExportXml />} />

        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  )
}
